import { render, staticRenderFns } from "./IndividualPost.vue?vue&type=template&id=898a46ce&"
import script from "./IndividualPost.vue?vue&type=script&lang=js&"
export * from "./IndividualPost.vue?vue&type=script&lang=js&"
import style0 from "./IndividualPost.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./IndividualPost.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports